var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5013 14.0812H14.0846V19.4979C14.0846 19.7852 13.9705 20.0608 13.7673 20.2639C13.5642 20.4671 13.2886 20.5812 13.0013 20.5812C12.714 20.5812 12.4384 20.4671 12.2353 20.2639C12.0321 20.0608 11.918 19.7852 11.918 19.4979V14.0812H6.5013C6.21398 14.0812 5.93843 13.9671 5.73527 13.7639C5.53211 13.5608 5.41797 13.2852 5.41797 12.9979C5.41797 12.7106 5.53211 12.435 5.73527 12.2319C5.93843 12.0287 6.21398 11.9146 6.5013 11.9146H11.918V6.49788C11.918 6.21057 12.0321 5.93502 12.2353 5.73185C12.4384 5.52869 12.714 5.41455 13.0013 5.41455C13.2886 5.41455 13.5642 5.52869 13.7673 5.73185C13.9705 5.93502 14.0846 6.21057 14.0846 6.49788V11.9146H19.5013C19.7886 11.9146 20.0642 12.0287 20.2673 12.2319C20.4705 12.435 20.5846 12.7106 20.5846 12.9979C20.5846 13.2852 20.4705 13.5608 20.2673 13.7639C20.0642 13.9671 19.7886 14.0812 19.5013 14.0812Z",
    fill: "#3F46AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/add_plus.33292fc16ba3e9fb5a6dbe26d8ffc714.svg";
export { ForwardRef as ReactComponent };